<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="share.1"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path id="Path_7747" data-name="Path 7747" d="M0,0H20V20H0Z" fill="none" />
    <path
      id="Path_7748"
      data-name="Path 7748"
      d="M7.794,9.984a2.223,2.223,0,1,1-3.143,0,2.222,2.222,0,0,1,3.143,0"
      transform="translate(-0.667 -1.555)"
      fill="none"
      :stroke="clr ? clr : '#768391'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
    />
    <path
      id="Path_7749"
      data-name="Path 7749"
      d="M18.46,4.651a2.223,2.223,0,1,1-3.143,0,2.223,2.223,0,0,1,3.143,0"
      transform="translate(-2.444 -0.667)"
      fill="none"
      :stroke="clr ? clr : '#768391'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
    />
    <path
      id="Path_7750"
      data-name="Path 7750"
      d="M18.46,15.317a2.223,2.223,0,1,1-3.143,0,2.223,2.223,0,0,1,3.143,0"
      transform="translate(-2.444 -2.444)"
      fill="none"
      :stroke="clr ? clr : '#768391'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
    />
    <path
      id="Path_7751"
      data-name="Path 7751"
      d="M9.04,10.317,13.973,7.85"
      transform="translate(-1.507 -1.308)"
      fill="none"
      :stroke="clr ? clr : '#768391'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
    />
    <path
      id="Path_7752"
      data-name="Path 7752"
      d="M9.04,13.19l4.933,2.467"
      transform="translate(-1.507 -2.198)"
      fill="none"
      :stroke="clr ? clr : '#768391'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
    />
  </svg>
</template>
